/**
 * Responsive point count utilities
 * Calculates max points based on container width for responsive behavior
 */

// Responsive point count thresholds
// These constants are centralized here and exported for use across the LineChart component
export const MIN_POINTS = 6;
export const MAX_POINTS = 16;
export const WIDTH_FOR_MIN_POINTS = 500; // Width at which we show minimum points
export const WIDTH_FOR_MAX_POINTS = 800; // Width at which we show maximum points

export interface ResponsivePointsConfig {
  minPoints?: number;
  maxPoints?: number;
  widthForMinPoints?: number;
  widthForMaxPoints?: number;
}

/**
 * Calculate responsive max points based on container width.
 * Linearly interpolates between MIN_POINTS and MAX_POINTS.
 */
export const getResponsiveMaxPoints = (
  containerWidth: number | null,
  config: ResponsivePointsConfig = {}
): number => {
  const {
    minPoints = MIN_POINTS,
    maxPoints = MAX_POINTS,
    widthForMinPoints = WIDTH_FOR_MIN_POINTS,
    widthForMaxPoints = WIDTH_FOR_MAX_POINTS,
  } = config;

  if (!containerWidth || containerWidth <= widthForMinPoints) return minPoints;
  if (containerWidth >= widthForMaxPoints) return maxPoints;

  // Linear interpolation between min and max
  const ratio =
    (containerWidth - widthForMinPoints) / (widthForMaxPoints - widthForMinPoints);
  return Math.round(minPoints + ratio * (maxPoints - minPoints));
};
